import { reactComponentsCustomThemeConfig } from '@pba/react-components';
import {
  type CustomThemeConfig,
  type CustomThemeConfigOverride,
  ThemeProvider,
  reactThemeCustomThemeConfig,
} from '@pba/react-theme';
import variables from 'common/styles/variables.json';
import { AntdTheme, type AntdThemeProperties } from './antd-theme';
import { webCustomThemeConfig } from './default-theme';

const defaultTheme: CustomThemeConfig = {
  ...reactThemeCustomThemeConfig,
  ...reactComponentsCustomThemeConfig,
  ...webCustomThemeConfig,
};

const overrideTheme: CustomThemeConfigOverride = {
  color: {
    primary: { default: variables.brandColor.value },
  },
  reactComponents: {
    menu: { itemMarginBlock: variables.spaceXs.value },
  },
};

const ConfigProvider = (props: AntdThemeProperties) => (
  <ThemeProvider defaultTheme={defaultTheme} overrideTheme={overrideTheme}>
    <AntdTheme {...props} />
  </ThemeProvider>
);

export default ConfigProvider;
